import axios from 'axios';

const api = axios.create({
   
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 15000,
});

// Global 401 response interceptor - clears stale auth on unauthorized responses
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const errorMessage = error.response.data?.error || error.response.data?.message || '';
      if (errorMessage === 'TOKEN_EXPIRED' || errorMessage === 'INVALID_ID_TOKEN' || errorMessage === 'Unauthorized') {
        localStorage.removeItem('idToken');
        localStorage.removeItem('user');
      }
    }
    return Promise.reject(error);
  },
);

export default api;
